import { PostRequest, GetRequest } from "./HttpService";

export const getAuditLogs = async (filter) => {
  const response = await PostRequest("/Audit/get-logs", filter);
  return response.json();
};

export const getAuditCategories = async () => {
  return GetRequest("/Audit/categories");
};
